import rule from './modules/rule'

const modules = {
  rule,
}

// Flattened statically rather than via router.addRoute so registration order
// stays identical to the module map declaration order.
export const moduleRoutes = Object.values(modules).flatMap(
  module => module.routes ?? [],
)

export default modules
